import createIcon from './createIcon';

export default createIcon(require('./motorcycle.svg'));